var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-center-main"},[_vm._v(" 很抱歉，本网站电脑端不可用，烦请用手机打开。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }